import React from 'react';

const IconError = props => (
  <svg width="32" height="32" viewBox="0 0 32 32" {...props}>
    <g>
      <circle cx="16" cy="16" r="16" fill="#D72828" />
      <path d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z" fill="#E6E6E6" />
    </g>
  </svg>
);

export default IconError;
